<template>
  <div>
    <v-container>
      <br />
      <v-alert
        dense
        text
        type="success"
        dismissible
        close-icon="mdi-delete"
        v-if="mostrar_alerta"
        >Solicitud registrada exitosamente</v-alert
      >
      <div class="form-group row" style="margin-top: 45px">
        <h4 style="color: #1C2546">Agregar gasto</h4>
      </div>
      <v-select
        v-model="locacion_solicitud"
        :items="values_tipo_solicitud"
        item-value="id"
        item-text="value"
        label="Tipo de Solicitud"
        :rules="[(v) => !!v || 'Seleccione un tipo de solicitud']"
        required
      ></v-select>
      <v-select
        v-model="forma_solicitud"
        :items="values_forma_solicitud"
        item-value="id"
        item-text="value"
        label="Forma de solicitud"
        v-if="locacion_solicitud === 1"
      ></v-select>
      <v-dialog v-model="dialog_group_form" width="60%">
        <v-card>
          <v-card-title
            ><span class="headline">Crear un grupo</span></v-card-title
          >
          <v-card-text>
            <v-form ref="form_grupo">
              <v-row>
                <v-text-field
                  v-model="nombre_grupo"
                  label="Nombre del grupo"
                  :rules="[(v) => !!v || 'Escriba un nombre del grupo']"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-textarea
                  v-model="descripcion_grupo"
                  label="Descripcion del grupo"
                ></v-textarea>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog_group_form = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="blue darken-1"
              text
              @click="create_grupo"
              :disabled="is_waiting"
            >
              <label v-if="!is_waiting">Guardar</label>
              <v-progress-circular
                small
                indeterminate
                color="primary"
                v-if="is_waiting"
                :size="20"
              ></v-progress-circular>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Form requesting xml file -->
      <div v-if="locacion_solicitud === 1 && forma_solicitud === 1">
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                accept="text/xml"
                label="Favor de subir el archivo XML de la factura"
                v-model="solicitud.archivo"
                :rules="[
                  (value) =>
                    !value || value.size > 0 || 'Suba un archivo valido',
                ]"
                required
                @change="analize_xml"
              ></v-file-input>
              <div v-if="mostrar_cargar">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                Cargando y validando datos...
              </div>
              <div v-if="mostrar_error_xml">
                <p class="red--text">{{ texto_error }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-file-input
                accept="application/pdf"
                label="(Opcional) Favor de subir el archivo PDF de la factura"
                v-model="solicitud.anexo_cfdi"
                :rules="[
                  (value) =>
                    !value || value.size > 0 || 'Suba un archivo valido',
                ]"
                required
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-select
                prepend-icon="mdi-account"
                v-model="solicitud.id_deudor"
                :items="deudores"
                item-text="nombre"
                item-value="id_user"
                label="Deudor"
                :readonly="readonlydeudor"
                filled
                @change="onchange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                prepend-icon="mdi-calendar"
                label="Fecha de Solicitud"
                v-model="solicitud.fecha_solicitud"
                data-date-format="mm-dd-yyyy"
                readonly
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                prepend-icon="mdi-currency-usd"
                label="Importe"
                v-model="solicitud.total"
                readonly
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-select
                :items="divisas"
                item-text="divisa"
                item-value="id_divisa"
                prepend-icon="mdi-cash-usd-outline"
                label="Divisa"
                v-model="solicitud.id_divisa"
                readonly
                filled
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-select
                :items="cuentas"
                item-text="nombre_cuenta"
                item-value="id_cuenta"
                prepend-icon="mdi-badge-account-horizontal-outline"
                label="Tipo Gasto"
                v-model="solicitud.id_cuenta"
                @change="show_anexo_form"
                :rules="[(v) => !!v || 'Seleccione una cuenta']"
                required
              ></v-select>
            </v-col>
          </v-row>
          <div v-if="requiere_descripcion">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  prepend-icon="mdi-text-subject"
                  label="Comentarios"
                  v-model="solicitud.comentarios"
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
          <div v-if="propina">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-file-input
                  accept="application/pdf, image/png, image/jpeg"
                  label="Favor de subir el archivo de la propina"
                  v-model="solicitud.archivo_propina"
                  :rules="[
                    (value) =>
                      !value || value.size > 0 || 'Suba un archivo valido',
                  ]"
                ></v-file-input>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  type="number"
                  prepend-icon="mdi-currency-usd"
                  label="Monto Propina"
                  v-model="solicitud.propina"
                  :rules="[(v) => !!v || 'Escriba el monto de la propina']"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="descripcion_propina">
              <v-col cols="12" sm="6" md="6">
                <v-textarea
                  prepend-icon="mdi-text-subject"
                  label="Descripción de propina"
                  v-model="solicitud.descripcion_propina"
                  :rules="[(v) => !!v || 'Escriba una descripción']"
                  required
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-textarea
                  prepend-icon="mdi-text-subject"
                  label="Comensales"
                  v-model="solicitud.comensales_propina"
                  :rules="[(v) => !!v || 'Escriba los comensales']"
                  required
                ></v-textarea>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                prepend-icon="mdi-text-subject"
                label="Descripción"
                v-model="solicitud.descripcion"
                readonly
                filled
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-checkbox
              v-model="checkbox_grupo"
              label="Agregar la solicitud a un grupo?"
            ></v-checkbox>
          </v-row>
          <v-row v-if="checkbox_grupo">
            <v-col cols="12" sm="8" md="8">
              <v-select
                prepend-icon="mdi-account-box-multiple"
                label="Grupos"
                :items="grupos"
                item-value="id_grupo"
                item-text="nombre"
                v-model="solicitud.id_grupo"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-btn @click="show_form_group">Agregar un nuevo grupo</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-btn class="mr-4" @click="submit_xml" :disabled="is_waiting">
                <label v-if="!is_waiting">Enviar</label>
                <v-progress-circular
                  :size="20"
                  indeterminate
                  color="primary"
                  v-if="is_waiting"
                ></v-progress-circular>
              </v-btn>
              <v-btn @click="reset">Cancelar</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <!-- Form requesting pdf/jpg file -->
      <v-form
        v-if="
          locacion_solicitud === 2 ||
            (locacion_solicitud === 1 && forma_solicitud === 2)
        "
        ref="form_pdf"
      >
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-file-input
              accept="application/pdf, image/png, image/jpeg"
              label="Favor de subir el archivo .pdf/.jpg de la factura"
              v-model="solicitud_sin_factura.archivo"
              :rules="[
                (value) => !value || value.size > 0 || 'Suba un archivo valido',
              ]"
              required
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-select
              prepend-icon="mdi-account"
              v-model="solicitud_sin_factura.id_deudor"
              :items="deudores"
              item-text="nombre"
              item-value="id_user"
              label="Deudor"
              :readonly="readonlydeudor"
              filled
              @change="onchange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="solicitud_sin_factura.fecha_solicitud"
                  label="Fecha Comprobación"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  :rules="[(v) => !!v || 'Seleccione una fecha']"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                :max="new Date().toISOString().slice(0, 10)"
                v-model="solicitud_sin_factura.fecha_solicitud"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              prepend-icon="mdi-text-short"
              label="Número de Factura"
              v-model="solicitud_sin_factura.numero_factura"
              :rules="[(v) => !!v || 'Escriba el número de factura']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              type="number"
              prepend-icon="mdi-currency-usd"
              label="Importe"
              v-model="solicitud_sin_factura.total"
              :rules="[(v) => !!v || 'Escriba el total']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-select
              :items="divisas"
              item-text="divisa"
              item-value="id_divisa"
              prepend-icon="mdi-cash-usd-outline"
              label="Divisa"
              v-model="solicitud_sin_factura.id_divisa"
              :rules="[(v) => !!v || 'Seleccione una divisa']"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              type="number"
              prepend-icon="mdi-currency-usd"
              label="Tipo Cambio"
              v-model="solicitud_sin_factura.monto_cambio"
              :rules="[(v) => !!v || 'Escriba el monto de cambio']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field 
              type="number" 
              prepend-icon="mdi-currency-usd"
              label="Importe Moneda Nacional"
              disabled
              :value="solicitud_sin_factura.monto_cambio*solicitud_sin_factura.total"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="6">
            <v-select
              :items="cuentas"
              item-text="nombre_cuenta"
              item-value="id_cuenta"
              prepend-icon="mdi-badge-account-horizontal-outline"
              label="Tipo Gasto"
              v-model="solicitud_sin_factura.id_cuenta"
              @change="necesita_propina"
              :rules="[(v) => !!v || 'Seleccione una cuenta']"
              required
            ></v-select>
          </v-col>
        </v-row>
        <div v-if="requiere_descripcion_pdf">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                prepend-icon="mdi-text-subject"
                label="Comentarios"
                v-model="solicitud_sin_factura.comentarios"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
        <div v-if="propina_pdf">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-file-input
                accept="application/pdf, image/png, image/jpeg"
                label="Favor de subir el archivo de la propina"
                v-model="solicitud_sin_factura.archivo_propina"
                
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                type="number"
                prepend-icon="mdi-currency-usd"
                label="Monto Propina"
                v-model="solicitud_sin_factura.propina"

              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="descripcion_propina_pdf">
            <v-col cols="12" sm="6" md="6">
              <v-textarea
                prepend-icon="mdi-text-subject"
                label="Descripción de propina"
                v-model="solicitud_sin_factura.descripcion_propina"
                
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-textarea
                prepend-icon="mdi-text-subject"
                label="Comensales"
                v-model="solicitud_sin_factura.comensales_propina"
                
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-textarea
              prepend-icon="mdi-text-subject"
              label="Descripción"
              v-model="solicitud_sin_factura.descripcion"
              :rules="[(v) => !!v || 'Escriba una descripción']"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-checkbox
            v-model="checkbox_grupo"
            label="Agregar la solicitud a un grupo?"
          ></v-checkbox>
        </v-row>
        <v-row v-if="checkbox_grupo">
          <v-col cols="12" sm="8" md="8">
            <v-select
              prepend-icon="mdi-account-box-multiple"
              label="Grupos"
              :items="grupos"
              item-value="id_grupo"
              item-text="nombre"
              v-model="solicitud_sin_factura.id_grupo"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-btn @click="show_form_group">Agregar un nuevo grupo</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex" cols="12" sm="12">
            <v-btn class="mr-4" @click="submit_pdf" :disabled="is_waiting"
              ><label v-if="!is_waiting">Enviar</label>
              <v-progress-circular
                :size="20"
                indeterminate
                color="primary"
                v-if="is_waiting"
              ></v-progress-circular
            ></v-btn>
            <v-btn @click="reset_pdf">Cancelar</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import router from "../router/index.js";
export default {
  data() {
    return {
      values_forma_solicitud: [
        { id: 1, value: "CFDI" },
        { id: 2, value: "Recibo" },
      ],
      values_tipo_solicitud: [
        { id: 1, value: "Gasto Nacional" },
        { id: 2, value: "Gasto Internacional" },
      ],
      cuentas: [],
      divisas: [],
      dialog_group_form: false,
      checkbox_grupo: false,
      user: null,
      id_deudor: null,
      deudor: null,
      forma_solicitud: null,
      type_solicitud: null,
      menu2: false,
      propina: false,
      mostrar_cargar: false,
      mostrar_error_xml: false,
      propina_pdf: false,
      solicitud: {},
      solicitud_sin_factura: {},
      deudores: [],
      readonlydeudor: false,
      result_test: null,
      mostrar_alerta: false,
      descripcion_propina: false,
      descripcion_propina_pdf: false,
      id_deudor_original: "",
      locacion_solicitud: "",
      texto_error: "",
      nombre_grupo: "",
      descripcion_grupo: "",
      grupos: [],
      date_today: null,
      is_waiting: false,
      requiere_descripcion_pdf: false,
    };
  },
  mounted() {
    // Config for axios
    axios.defaults.headers.common["access-token"] = this.$store.state.token;
    axios.interceptors.response.use(function(response) {
      if (response.data.message == "Token inválida") {
        router.push({ name: "login", params: { errorToken: "true" } });
      } else {
        return response;
      }
    });
    // End config for axios
    this.get_cuentas();
    this.get_deudor();
    this.get_divisas();
    this.get_deudores();
  },
  methods: {
    analize_xml() {
      if (this.solicitud.archivo !== null) {
        if (
          this.solicitud.archivo !== undefined &&
          this.solicitud.archivo.size > 0
        ) {
          this.mostrar_error_xml === true
            ? (this.mostrar_error_xml = false)
            : "";
          this.mostrar_cargar = true;
          let form_file = new FormData();
          form_file.append("file", this.solicitud.archivo);
          axios
            .post(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/archivos/analizar",
              form_file
            )
            .then((res) => {
              if(res.data.rfc_receptor!='SME980702916')
              {
                this.texto_error = "La solicitud no fue emitida a Bollore";
                this.mostrar_error_xml = true;
                this.mostrar_cargar = false
                this.is_waiting=true
                return false
              }
              
              axios
                .get(
                  `https://` +
                    process.env.VUE_APP_URL +
                    `:3000/gastos/api/v1/solicitudes/archivos/validarcfdi/${res.data.uuid}/${res.data.rfc_emisor}/${res.data.rfc_receptor}/${res.data.total}/${res.data.divisa}`
                )
                .then((validate_cfdi) => {
                  if (
                    validate_cfdi.data.status ===
                    "solictud no registrada anteriormente"
                  ) {
                    let fecha = res.data.fecha_solicitud.split("/");
                    this.solicitud.subtotal = res.data.subtotal;
                    this.solicitud.total = res.data.total;
                    this.solicitud.iva = res.data.iva;
                    this.solicitud.descripcion = res.data.descripcion;
                    this.solicitud.fecha_solicitud =
                      fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                    this.solicitud.id_divisa = res.data.id_divisa;
                    this.solicitud.id_tipo_archivo_solicitud = this.forma_solicitud;
                    this.solicitud.uuid = res.data.uuid;
                    this.solicitud.rfc_emisor = res.data.rfc_emisor;
                    this.solicitud.rfc_receptor = res.data.rfc_receptor;
                    this.solicitud.serie_xml = res.data.serie;
                    this.solicitud.descuento =
                      res.data.descuento != undefined ? res.data.descuento : 0;
                    this.solicitud.otrosimpuestos =
                      res.data.otrosimpuestos != undefined
                        ? res.data.otrosimpuestos
                        : 0;
                    this.solicitud.totalImpuestosTraslados =
                      res.data.totalImpuestosTraslados != undefined
                        ? res.data.totalImpuestosTraslados
                        : 0;
                  } else {
                    this.texto_error = validate_cfdi.data.status;
                    this.mostrar_error_xml = true;
                  }
                  this.mostrar_cargar = false;
                });
            });
        } else {
          if (this.mostrar_error_xml === true) {
            this.mostrar_error_xml = false;
          }
          if (this.mostrar_cargar === true) {
            this.mostrar_cargar = false;
          }
          this.solicitud.fecha_solicitud = "";
          this.solicitud.total = "";
          this.solicitud.id_divisa = null;
          this.solicitud.descripcion = "";
        }
      } else {
        if (this.mostrar_error_xml === true) {
          this.mostrar_error_xml = false;
        }
        if (this.solicitud.fecha_solicitud !== "") {
          this.reset();
        }
        if (this.mostrar_cargar === true) {
          this.mostrar_cargar = false;
        }
      }
    },
    show_anexo_form() {
      var obj_selected = this.cuentas.filter((obj) => {
        return obj.id_cuenta === this.solicitud.id_cuenta;
      });
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.propina = true;
      } else {
        this.propina = false;
      }
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripcion_propina = true;
      } else {
        this.descripcion_propina = false;
      }
      if (obj_selected[0]["requiere_descripcion"] === true) {
        this.requiere_descripcion = true;
      } else {
        this.requiere_descripcion = false;
      }
    },
    show_form_group() {
      this.dialog_group_form = true;
      if (this.$refs.form_grupo) {
        this.$refs.form_grupo.reset();
      }
    },
    get_grupos() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupos/" +
            this.get_deudor_actual()
        )
        .then((res) => {
          this.grupos = res.data;
        });
    },
    create_grupo() {
      if (this.$refs.form_grupo.validate()) {
        this.is_waiting = true;
        var grupo = [
          {
            nombre_grupo: this.nombre_grupo,
            descripcion_grupo: this.descripcion_grupo,
            id_deudor: this.get_deudor_actual(),
          },
        ];
        try {
          axios
            .post(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/grupos",
              grupo
            )
            .then(() => {
              this.get_grupos();
              this.dialog_group_form = false;
              this.is_waiting = false;
            });
        } catch (error) {
          this.is_waiting = false;
        }
      }
    },
    get_deudor_actual() {
      var deudor = "";
      if (this.locacion_solicitud === 1 && this.forma_solicitud === 1) {
        deudor = this.solicitud.id_deudor;
      }
      if (
        this.locacion_solicitud === 2 ||
        (this.locacion_solicitud === 1 && this.forma_solicitud === 2)
      ) {
        deudor = this.solicitud_sin_factura.id_deudor;
      }
      if (this.locacion_solicitud === null || this.forma_solicitud === null) {
        deudor = this.id_deudor_original;
      }
      return deudor;
    },
    create_formdata_solicitud(solicitud) {
      var dataform_solicitud = new FormData();
      dataform_solicitud.append("file", solicitud.archivo);
      dataform_solicitud.append("file_anexo_cfdi", solicitud.anexo_cfdi);
      dataform_solicitud.append("id_deudor", solicitud.id_deudor);
      dataform_solicitud.append("id_deudor_original", this.id_deudor_original);
      dataform_solicitud.append("total", solicitud.total);
      if (solicitud.id_tipo_solicitud === 2) {
        dataform_solicitud.append("fecha_solicitud", solicitud.fecha_solicitud);
      } else {
        let fecha_format = solicitud.fecha_solicitud.split("/");
        dataform_solicitud.append(
          "fecha_solicitud",
          fecha_format[2] + "-" + fecha_format[1] + "-" + fecha_format[0]
        );
      }
      dataform_solicitud.append(
        "id_tipo_solicitud",
        solicitud.id_tipo_solicitud
      );
      dataform_solicitud.append("descripcion", solicitud.descripcion);
      dataform_solicitud.append("subtotal", solicitud.subtotal);
      dataform_solicitud.append("iva", solicitud.iva);
      dataform_solicitud.append("id_divisa", solicitud.id_divisa);
      dataform_solicitud.append("id_cuenta", solicitud.id_cuenta);
      dataform_solicitud.append("anexo", solicitud.archivo_propina);
      dataform_solicitud.append(
        "id_locacion_solicitud",
        this.locacion_solicitud
      );
      dataform_solicitud.append(
        "id_tipo_archivo_solicitud",
        solicitud.id_tipo_archivo_solicitud
      );
      dataform_solicitud.append("deudor", this.deudor);
      dataform_solicitud.append("propina", solicitud.propina);
      dataform_solicitud.append("uuid", solicitud.uuid);
      dataform_solicitud.append("rfc_emisor", solicitud.rfc_emisor);
      dataform_solicitud.append("rfc_receptor", solicitud.rfc_receptor);
      dataform_solicitud.append("monto_cambio", solicitud.monto_cambio);
      dataform_solicitud.append(
        "descripcion_propina",
        solicitud.descripcion_propina
      );
      dataform_solicitud.append(
        "comensales_propina",
        solicitud.comensales_propina
      );
      dataform_solicitud.append(
        "id_forma_solicitud",
        solicitud.id_forma_solicitud
      );
      dataform_solicitud.append("numero_factura", solicitud.numero_factura);
      dataform_solicitud.append("serie_xml", solicitud.serie_xml);
      dataform_solicitud.append("comentarios", solicitud.comentarios);
      dataform_solicitud.append("id_grupo", solicitud.id_grupo);
      dataform_solicitud.append("descuento", solicitud.descuento);
      dataform_solicitud.append("otrosimpuestos", solicitud.otrosimpuestos);
      dataform_solicitud.append(
        "totalImpuestosTraslados",
        solicitud.totalImpuestosTraslados
      );
      return dataform_solicitud;
    },
    submit_xml() {
      this.mostrar_alerta = false;
      if (this.$refs.form.validate()) {
        this.is_waiting = true;
        this.solicitud.id_tipo_solicitud = 2;
        this.solicitud.id_locacion_solicitud = 1;
        this.solicitud.id_forma_solicitud = 1;
        this.solicitud.monto_cambio = 0.0;
        this.solicitud.numero_factura = "";
        /*
        if (this.propina) {
          this.solicitud.propina = parseFloat(this.solicitud.total*0.10).toFixed(2);
        }
        */
        var solicitud = this.create_formdata_solicitud(this.solicitud);
        axios
          .post(
            "https://" +
              process.env.VUE_APP_URL +
              ":3000/gastos/api/v1/solicitudes",
            solicitud
          )
          .then(() => {
            //this.result_test = res.data;
            this.reset();
            this.mostrar_alerta = true;
          });
      }
    },
    submit_pdf() {
      this.mostrar_alerta = false;
      if (this.$refs.form_pdf.validate()) {
        this.is_waiting = true;
        this.solicitud_sin_factura.id_tipo_solicitud = 2;
        this.solicitud_sin_factura.id_forma_solicitud = 2;
        this.solicitud_sin_factura.descuento = 0;
        this.solicitud_sin_factura.otrosimpuestos = 0;
        this.solicitud_sin_factura.totalImpuestosTraslados = 0;
        this.solicitud.id_locacion_solicitud = 1;
        var iva = parseFloat(
          parseFloat(this.solicitud_sin_factura.total) * 0.16
        );
        var subtotal = parseFloat(this.solicitud_sin_factura.total) - iva;
        iva = iva.toFixed(2);
        subtotal = subtotal.toFixed(2);
        /*
        if (this.propina_pdf===true) {
          this.solicitud_sin_factura.propina = parseFloat(this.solicitud_sin_factura.total*0.10).toFixed(2);
        }
        */
        this.solicitud_sin_factura.iva = iva;
        this.solicitud_sin_factura.subtotal = subtotal;
        this.solicitud_sin_factura.id_tipo_archivo_solicitud = 2;
        var solicitud = this.create_formdata_solicitud(
          this.solicitud_sin_factura
        );
        axios
          .post(
            "https://" +
              process.env.VUE_APP_URL +
              ":3000/gastos/api/v1/solicitudes",
            solicitud
          )
          .then(() => {
            this.reset_pdf();
            this.mostrar_alerta = true;
          });
      }
    },
    get_cuentas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/cuentas"
        )
        .then((res) => {
          this.cuentas = res.data;
        });
    },
    get_deudor() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/usuarios/" +
            this.$store.state.token
        )
        .then((res) => {
          this.deudor = res.data.nombre;
          this.solicitud.id_deudor = res.data.id_user;
          this.id_deudor_original = res.data.id_user;
          this.solicitud_sin_factura.id_deudor = res.data.id_user;
          this.get_grupos();
        });
    },
    get_deudores() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/select/empleados/comprobacion2/" +
            this.$store.state.user.id_puesto
        )
        .then((res) => {
          this.deudores = res.data;
          if (res.data.length <= 1) {
            this.readonlydeudor = true;
          }
        });
    },
    onchange(key) {
      this.deudores.forEach((element) => {
        if (element.id_user == key) {
          this.deudor = element.nombre;
        }
      });
      this.get_grupos();
    },
    get_divisas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/divisas"
        )
        .then((res) => {
          this.divisas = res.data;
        });
    },
    reset() {
      this.$refs.form.reset();
      this.get_deudor();
      this.mostrar_cargar = false;
      this.propina = false;
      this.descripcion_propina = false;
      this.requiere_descripcion = false;
      this.is_waiting = false;
    },
    reset_pdf() {
      this.$refs.form_pdf.reset();
      this.get_deudor();
      this.propina_pdf = false;
      this.descripcion_propina_pdf = false;
      this.requiere_descripcion_pdf = false;
      this.is_waiting = false;
    },
    necesita_propina() {
      var obj_selected = this.cuentas.filter((obj) => {
        return obj.id_cuenta === this.solicitud_sin_factura.id_cuenta;
      });
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.propina_pdf = true;
      } else {
        this.propina_pdf = false;
      }
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripcion_propina_pdf = true;
      } else {
        this.descripcion_propina_pdf = false;
      }
      if (obj_selected[0]["requiere_descripcion"] === true) {
        this.requiere_descripcion_pdf = true;
      } else {
        this.requiere_descripcion_pdf = false;
      }
    },
  },
};
</script>
